import {Injectable} from '@angular/core';
import {LokijsService} from './database/lokijs.service';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {CustomerModel} from '../models/customer.model';
import {PriceListModel} from '../models/price-list.model';
import {PriceListDetailModel} from '../models/price-list-detail.model';
import {DocumentModel} from '../models/document.model';

@Injectable({
    providedIn: 'root'
})
export class FindProductPriceService {

    constructor(private lokiJs: LokijsService) {

    }

    async getPrice(prod: DetaillineDTOModel, cust: CustomerModel) {
        if( !cust ){
            cust = new CustomerModel(); 
        }
        let currentDetailPriceList: PriceListDetailModel[] = null;
        let currentPriceList: PriceListModel[] = await this.lokiJs.getTable('pricelist', 'nsuk').chain()
            .find({cod: cust.pricelist}).data();
        if (currentPriceList.length > 0 && cust.name) {
            console.log(currentPriceList);
            currentDetailPriceList = await this.lokiJs.getTable('pricelistdetails', 'id')
                .chain().find({pricelistId: currentPriceList[0].nsuk})
                .find({'$or': [{productId: prod.productId}, {productTypeId: prod.id}]}).data();
            if (currentDetailPriceList.length > 0) {
                console.log(currentDetailPriceList[0]);
                return {'price': currentDetailPriceList[0].sellPrice, 'tender': cust.pricelist};
            } else {
                if (currentPriceList[0].parent) {
                    currentPriceList = await this.lokiJs.getTable('pricelist', 'nsuk').chain()
                        .find({cod: currentPriceList[0].parent.cod}).data();
                    if (currentPriceList.length > 0) {
                        currentDetailPriceList = await this.lokiJs.getTable('pricelistdetails', 'id')
                            .chain().find({pricelistId: currentPriceList[0].nsuk})
                            .find({'$or': [{productId: prod.productId}, {productTypeId: prod.id}]}).data();
                        if (currentDetailPriceList.length > 0) {
                            console.log(currentDetailPriceList);
                            console.log(currentDetailPriceList[0]);
                            return {'price': currentDetailPriceList[0].sellPrice, 'tender': currentPriceList[0].parent.cod};
                        }
                    }
                }
            }
        }
        // Last case will return the current sell price
        return {'price': prod.currentSellPrice, 'tender': 'STANDARD'};
    }

    async isDiscountable(tender: string) {
        const pricelist = await this.lokiJs.getTable('pricelist', 'nsuk')
            .chain().find({cod: tender}).data();
        return pricelist[0].discountable;
    }

    async getDiscount(cust: CustomerModel, tender?: string) {
        if (tender) {
            await this.isDiscountable(tender).then(res => {
                if (res === 0) {
                    return 0;
                } else {
                    return cust.hireDisc;
                }
            });
        } else {
            await this.isDiscountable(cust.tender).then(res => {
                if (res === 0) {
                    return 0;
                } else {
                    return cust.hireDisc;
                }
            });
        }
        return 0;
    }

    async findFinalPriceAndDiscount(line: DetaillineDTOModel, document: DocumentModel) {
        const res = await this.getPrice(line, document.customer);
        line.weeklyRate = res.price;
        const disc = await this.isDiscountable(res.tender);
        if (disc === 1 && document.customer && document.customer.name) {
            line.discount = document.customer.saleDisc;
        } else {
            line.discount = 0;
        }
        line.total = line.weeklyRate - (line.weeklyRate * line.discount / 100);
    }
}

